import React, { useContext } from 'react';
import { RicosViewerContext } from 'ricos-context';
import { GIPHY_TYPE } from './viewer-loadable.js';
import { Image } from 'wix-rich-content-ui-components';
import 'wix-rich-content-common';
import '@loadable/component';
import 'ricos-types';

var styles = {"giphy_player":"bpCfN","gifRatio":"lrAMV"};

var ROOT = "giphyPlayer";

var GiphyViewer = function GiphyViewer(props) {
  var componentData = props.componentData;
  var id = componentData.id,
    width = componentData.width,
    height = componentData.height;
  if (componentData.original.mp4) {
    return /* @__PURE__ */React.createElement("video", {
      role: "img",
      autoPlay: true,
      muted: true,
      loop: true,
      playsInline: true,
      "aria-label": "gif",
      "data-hook": ROOT,
      className: styles.giphy_player,
      src: componentData.original.mp4
    });
  }
  var isInfoForWixImageReady = id !== void 0 && width !== void 0 && height !== void 0;
  if (isInfoForWixImageReady) {
    var _style;
    return /* @__PURE__ */React.createElement(Image, {
      id: id,
      containerId: id + "-parent",
      role: "img",
      "aria-label": "gif",
      height: height,
      width: width,
      containerProps: {
        className: styles.gifRatio,
        containerId: id + "-parent",
        style: (_style = {}, _style["--dim-height"] = height, _style["--dim-width"] = width, _style),
        dataHook: ROOT
      },
      displayMode: "fill",
      className: styles.giphy_player,
      uri: componentData.original.gif,
      alt: "gif"
    });
  }
  return /* @__PURE__ */React.createElement("img", {
    role: "img",
    "aria-label": "gif",
    className: styles.giphy_player,
    src: componentData.original.gif,
    alt: "gif",
    "data-hook": ROOT
  });
};

var Giphy = function Giphy(_ref) {
  var node = _ref.node,
    nodeIndex = _ref.nodeIndex,
    NodeViewContainer = _ref.NodeViewContainer;
  var _useContext = useContext(RicosViewerContext),
    config = _useContext.config;
  return /* @__PURE__ */React.createElement(NodeViewContainer, {
    key: node.id,
    node: node,
    nodeIndex: nodeIndex
  }, /* @__PURE__ */React.createElement(GiphyViewer, {
    componentData: node.gifData,
    settings: config[GIPHY_TYPE]
  }));
};

export { Giphy as default };

import 'wix-rich-content-plugin-giphy/dist/loadable/viewer/es/styles.viewer.min.global.css'